// src/MenuExact.jsx
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./MenuExact.css";
import configIcon from "./assets/config.png";
import logoutIcon from "./assets/logout.png";
import { useI18n } from "./i18n/I18nContext";
import { translateMenuTree } from "./i18n/menuTranslate";

// ─────────────────────────────────────────────────────────
// CONSTANTES
// ─────────────────────────────────────────────────────────
const ETAPE_CONFIG = {
  Empilement:          { label: "Empilement",           icon: "📦" },
  Impregnation:        { label: "Imprégnation",         icon: "🧪" },
  TraitementThermique: { label: "Traitement Thermique", icon: "🔥" },
  Fabrication:         { label: "Fabrication",          icon: "🏭" },
  Aboutage:            { label: "Aboutage",             icon: "🔗" },
  Livraison:           { label: "Livraison",            icon: "🚚" },
  QualiteStack:        { label: "Contrôle Qualité",     icon: "🔬" },
};

const ORDRE_ETAPES = [
  "Empilement", "Impregnation", "TraitementThermique",
  "Fabrication", "Aboutage", "Livraison", "QualiteStack",
];

const SECTIONS = ["logistique", "production", "qualite", "rd", "dashboard"];

const MENU_FALLBACK = {
  logistique: [
    { id: "reception", label: "RÉCEPTION", children: [
      { id: "reception_bois",     label: "Bois",     path: "/logistique/reception/bois" },
      { id: "reception_resine",   label: "Résine",   path: "/logistique/reception/resine" },
      { id: "reception_amorceur", label: "Amorceur", path: "/logistique/reception/amorceur" },
    ]},
    { id: "stock", label: "SUIVI DE STOCK", children: [
      { id: "stock_bois",     label: "Bois",     path: "/logistique/stock/bois" },
      { id: "stock_resine",   label: "Résine",   path: "/logistique/stock/resine" },
      { id: "stock_amorceur", label: "Amorceur", path: "/logistique/stock/amorceur" },
    ]},
    { id: "prelevements_recap", label: "RÉCAP PRÉLÈVEMENTS", path: "/logistique/prelevements" },
    { id: "placages_decoupes", label: "PLACAGES DÉCOUPÉS", path: "/logistique/placages-decoupes" },
    { id: "stack", label: "SUIVI DE LIVRAISON STACK", path: "/logistique/stack" },
  ],
  production: [
    { id: "prelevement-decoupe",       label: "Prélèvement & Découpe",                                path: "/production/prelevement-decoupe" },
    { id: "conformite-pli",            label: "Conformité Pli",                                       path: "/production/conformite-pli" },
    { id: "tracabilite-pli",           label: "Traçabilité Pli (Classification / Tri)",               path: "/production/tracabilite-pli" },
    { id: "humidite-pli",              label: "Humidité Pli",                                         path: "/production/humidite-pli" },
    { id: "prep-amorceur",             label: "Prélèvement & Préparation Mélange de l'Amorceur",      path: "/production/amorceur-melange" },
    { id: "prep-resine-amorceur",      label: "Prélèvement & Préparation Mélange Résine & Amorceur",  path: "/production/solution-resine-amorceur" },
    { id: "rajout-resine-amorceur",    label: "Rajout de Mélange Résine & Amorceur",                  path: "/production/rajout-resine-amorceur" },
    { id: "empilement",                label: "Empilement",                                           path: "/production/empilement" },
    { id: "empilement-v2",             label: "Empilement v2 (28 plis)",                              path: "/production/empilement-v2" },
    { id: "impregnation",              label: "Imprégnation",                                         path: "/production/impregnation" },
    { id: "list-impregnation",         label: "Liste des impregnations ",                             path: "/production/list-impregnation" },
    { id: "prep-traitement-thermique", label: "Préparation Traitement Thermique",                     path: "/production/traitement-thermique" },
    { id: "conditionnement",           label: "Conditionnement",                                      path: "/production/conditionnement" },
    { id: "fabrication",               label: "Fabrication (Pressage + Cuisson + Refroidissement)",   path: "/production/fabrication" },
    { id: "aboutage",                  label: "Aboutage",                                             path: "/production/aboutage" },
    { id: "livraison-produit",         label: "Livraison de Produit (Finition Visual Qualité Check)", path: "/production/livraison" },
  ],
  qualite: [
    { id: "MP", label: "QUALITE MATIERE PREMIERE", children: [
      { id: "reception", label: "Analyse", children: [
        { id: "amorceur/resine", label: "Amorceur/Liant", path: "/qualite/MP/amoreceur_resine" },
        { id: "colle",           label: "Colle",          path: "/qualite/MP/colle" },
        { id: "bois",            label: "Bois",           path: "/qualite/MP/bois" },
      ]},
      { id: "suivi", label: "Resultat", children: [
        { id: "suivi_amorceur_resine", label: "Suivi Amorceur/Liant", path: "/qualite/MP/suivi_amoreceur_resine" },
        { id: "suivi_colle",           label: "Suivi Colle",          path: "/qualite/MP/suivi_colle" },
        { id: "suivi_bois",            label: "Suivi Bois",           path: "/qualite/MP/suivi_bois" },
      ]},
    ]},
    { id: "controleStack", label: "CONTROLE STACK LABO", children: [
      { id: "reception_stack", label: "Analyse", children: [
        { id: "flexion", label: "Flexion", path: "/qualite/controleStack/flexion" },
        { id: "ilss",    label: "ILSS",    path: "/qualite/controleStack/ilss" },
        { id: "controle_resine", label: "Controle Resine", path: "/qualite/controleStack/controle-resine" },
      ]},
      { id: "suivi_stack", label: "Resultat", children: [
        { id: "suivi_flexion", label: "Suivi Flexion", path: "/qualite/Stack/flexion" },
        { id: "suivi_ilss",    label: "Suivi ILSS",    path: "/qualite/Stack/ilss" },
        { id: "suivi_controle_resine", label: "Suivi Controle Resine", path: "/qualite/Stack/controle-resine" },
      ]},
    ]},
    { id: "controleStackQualite", label: "CONTROLE STACK QUALITE", children: [
      { id: "reception_qualite", label: "Analyse", children: [
        { id: "controle_stack", label: "Controle Stack", path: "/qualite/controleStack" },
      ]},
      { id: "suivi_qualite", label: "Resultat", children: [
        { id: "suivi_control_stack", label: "Suivi Controle Stack", path: "/qualite/MP/suivi_controlstack" },
        { id: "suivi_tomographie", label: "Tomographie", path: "/qualite/Stack/tomographie" },
      ]},
    ]},
    { id: "controleStackPlaneite", label: "CONTROLE STACK ABOUTAGE", children: [
      { id: "reception_aboutage", label: "Analyse", children: [
        { id: "controle_stack_planeite", label: "Controle Stack Aboutage", path: "/qualite/controleStack_planeite" },
      ]},
      { id: "suivi_aboutage", label: "Resultat", children: [
        { id: "suivi_control_stack_planeite", label: "Suivi Controle Stack Aboutage", path: "/qualite/suivi_controlstack_planeite" },
      ]},
    ]},
    { id: "export", label: "EXPORT", children: [
      { id: "export_excel", label: "Export Excel", path: "/qualite/export-excel" },
    ]},
  ],
  rd: [
  {
    id: "stacks", label: "STACKS", children: [
      { id: "fiche_stack", label: "Fiche Stack", path: "/rd/Stack/fiche" },
    ],
  },
],
  dashboard: [
    { id: "dashboard_qualite",    label: "Qualité",    path: "/dashboard/qualite" },
    { id: "dashboard_qualite_placages_densite", label: "Placages densité / largeur", path: "/dashboard/qualite/placages-densite" },
    { id: "dashboard_logistique", label: "Logistique", path: "/dashboard/logistique" },
    { id: "dashboard_production", label: "Production", path: "/dashboard/production" },
    { id: "dashboard_maestro", label: "Maestro — courbes presse", path: "/dashboard/maestro" },
    { id: "dashboard_maestro_thermocouples", label: "Maestro — thermocouples", path: "/dashboard/maestro/thermocouples" },
    { id: "dashboard_picolog", label: "PicoLog — courbes température", path: "/dashboard/picolog" },
  ],
};

// ─────────────────────────────────────────────────────────
// COMPOSANT PRINCIPAL
// ─────────────────────────────────────────────────────────
export default function MenuExact() {
  const [active, setActive]                 = useState(null);
  const [rawItems, setRawItems]             = useState([]);
  const [items, setItems]                   = useState([]);
  const [loading, setLoading]               = useState(false);
  const [err, setErr]                       = useState("");
  const [expandedItems, setExpandedItems]   = useState(new Set());
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Recherche
  const [searchPN, setSearchPN]               = useState("");
  const [searchResult, setSearchResult]       = useState(null);
  const [searchLoading, setSearchLoading]     = useState(false);
  const [suggestions, setSuggestions]         = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [expandedRows, setExpandedRows]       = useState(false);

  const resultRef     = useRef(null);
  const searchAreaRef = useRef(null);
  const debounceRef   = useRef(null);
  const navigate      = useNavigate();
  const { t, lang, ui } = useI18n();

  // Retraduire le menu quand la langue change
  useEffect(() => {
    setItems(translateMenuTree(rawItems, t));
  }, [rawItems, lang, t]);

  // ── Auth guard ───────────────────────────────────────────
  useEffect(() => {
    if (!localStorage.getItem("authToken")) navigate("/");
  }, [navigate]);

  // ── Fermeture avec Escape ────────────────────────────────
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && searchResult) handleCloseSearchResult();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [searchResult]);

  // ── Fermeture clic extérieur ─────────────────────────────
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchResult && searchAreaRef.current && !searchAreaRef.current.contains(e.target)) {
        handleCloseSearchResult();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [searchResult]);

  // ── Logout ───────────────────────────────────────────────
  function handleLogout() {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    navigate("/");
  }

  // ── Autocomplete ─────────────────────────────────────────
  async function fetchSuggestions(value) {
    if (value.trim().length < 2) { setSuggestions([]); setShowSuggestions(false); return; }
    try {
      const token = localStorage.getItem("authToken");
      const res   = await fetch(`/api/logistique/autocomplete?q=${encodeURIComponent(value)}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setSuggestions(data);
      setShowSuggestions(data.length > 0);
    } catch {
      setSuggestions([]);
    }
  }

  // ── Téléchargement Excel avec images des plis ────────────
async function handleDownloadStackExcel(stackId) {
  try {
    const token = localStorage.getItem("authToken");
    const res = await fetch(`/api/logistique/stack/${stackId}/export-excel`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!res.ok) throw new Error("Erreur lors de la génération de l'Excel");

    const blob = await res.blob();
    const url  = window.URL.createObjectURL(blob);
    const a    = document.createElement("a");
    a.href     = url;
    a.download = `Stack_${stackId}_Images.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("❌ Erreur de téléchargement Excel :", error);
    alert(t("common.excelError"));
  }
}

  function handleInputChange(e) {
    const value = e.target.value;
    setSearchPN(value);
    setShowSuggestions(false);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => fetchSuggestions(value), 300);
  }

  function handleSelectSuggestion(suggestion) {
    setSearchPN(suggestion.value);
    setSuggestions([]);
    setShowSuggestions(false);
  }

  // ── Détection type query ─────────────────────────────────
  function detectQueryType(query) {
    const q = query.toUpperCase();
    if (q.startsWith("IDS") || q.startsWith("STACK-")) return "stack";
    if (/ - \d+$/.test(query) || query.includes("_"))   return "plypn";
    return "pn";
  }

  // ── Recherche principale ─────────────────────────────────
  // ✅ FIX Bug 1 : endpoint dédié pour chaque type
async function handleSearchPN(e) {
  e.preventDefault();
  const query = searchPN.trim();
  if (!query) return;

  setSearchLoading(true);
  setSearchResult(null);
  setExpandedRows(false);
  setShowSuggestions(false);

  try {
    const token     = localStorage.getItem("authToken");
    const queryType = detectQueryType(query);

    // ✅ Stack et PlyPN vont tous les deux vers /search-plypn
    // Le backend détecte lui-même si c'est un stack (IDS...) et retourne data.type === "stack"
    const endpoint =
      queryType === "pn"
        ? `/api/logistique/search-pn?pn=${encodeURIComponent(query)}`
        : `/api/logistique/search-plypn?plypn=${encodeURIComponent(query)}`;

    const res = await fetch(endpoint, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!res.ok) {
      setSearchResult({ found: false, message: `❌ "${query}" ${t("common.notFound")}` });
      return;
    }

    const data = await res.json();

    // ✅ Le backend renvoie type:"stack" quand il détecte un IDS
    if (data.type === "stack") {
      setSearchResult({
        found:   true,
        type:    "stack",
        stackId: data.stackId,
        etapes:  data.etapes,
        ordre:   data.ordre || ORDRE_ETAPES,
      });
      return;
    }

    if (queryType === "plypn") {
      setSearchResult({
        found:       true,
        type:        "plypn",
        plypn:       data.PlyPN,
        etape:       data.Etape,
        stackId:     data.StackId,
        position:    data.Position,
        totalPlis:   data.TotalPlis,
        operateur:   data.Operateur,
        date:        data.Date,
        imageUrl:    data.ImageUrl || null,
        imageCorrected: !!data.ImageCorrected,
        commentaire: data.Commentaire,
        details: {
          melangePN:   data.MelangePN,
          temperature: data.Temperature,
          enceinte:    data.EnceinteId,
          strategie:   data.Strategie,
          parcPresse1: data.ParcPresse1,
          parcPresse2: data.ParcPresse2,
        },
      });
      return;
    }

    setSearchResult({
      found:       true,
      type:        "pn",
      pn:          data.PN,
      etat:        data.Etat,
      fournisseur: data.Fournisseur,
      date:        data.Date,
    });

  } catch (error) {
    console.error("❌ Erreur recherche:", error);
    setSearchResult({ found: false, message: `❌ ${t("common.searchError")}` });
  } finally {
    setSearchLoading(false);
  }
}

  function handleCloseSearchResult() {
    setSearchPN("");
    setSearchResult(null);
    setExpandedRows(false);
    setSuggestions([]);
    setShowSuggestions(false);
  }

  // ── Navigation par onglet ────────────────────────────────
  // ✅ FIX Bug 4 : gestion des erreurs HTTP non-401
  async function onTab(section) {
    setActive(section);
    setRawItems([]);
    setErr("");
    setExpandedItems(new Set());
    setLoading(true);
    setMobileMenuOpen(false);

    try {
      const token = localStorage.getItem("authToken");
      if (!token) { setErr(t("common.sessionExpired")); navigate("/"); return; }

      const r = await fetch(`/api/menu/${section}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (r.status === 401) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("user");
        window.location.href = "/";
        return;
      }

      // ✅ FIX Bug 4 : on ne parse pas une réponse d'erreur comme des items
      if (!r.ok) throw new Error(`${t("common.errorServer")} (HTTP ${r.status})`);

      setRawItems(await r.json());
    } catch (e) {
      setRawItems(MENU_FALLBACK[section] || []);
      setErr(`${t("common.apiUnreachable")} (${e.message})`);
    } finally {
      setLoading(false);
    }
  }

  // ── Toggle menu item ─────────────────────────────────────
  function toggleExpand(itemId) {
    setExpandedItems((prev) => {
      const next = new Set(prev);
      next.has(itemId) ? next.delete(itemId) : next.add(itemId);
      return next;
    });
  }

  // ── Render menu item (récursif) ──────────────────────────
  function renderItem(item) {
    const hasChildren = item.children?.length > 0;
    const isExpanded  = expandedItems.has(item.id);

    if (hasChildren) {
      return (
        <div key={item.id} className="list-item-wrapper">
          <button className="list-btn list-btn-parent" onClick={() => toggleExpand(item.id)}>
            <span>{item.label}</span>
            <span className="expand-icon">{isExpanded ? "−" : "+"}</span>
          </button>
          {isExpanded && (
            <div className="submenu">{item.children.map(renderItem)}</div>
          )}
        </div>
      );
    }

    return (
      <div key={item.id} className="list-item-wrapper">
        <button className="list-btn list-btn-child" onClick={() => (window.location.href = item.path)}>
          {item.label}
        </button>
      </div>
    );
  }

  // ── Render résultat Stack ────────────────────────────────
  // ✅ FIX Bug 2 : result.ordre utilisé pour la timeline
  function renderStackResult(result) {
  const ordreAffiche = result.ordre || ORDRE_ETAPES;

  return (
    <>
      {/* --- MODIFICATION ICI : Ajout du bouton d'export Excel --- */}
      <div className="result-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span>📦 <strong>Stack : {result.stackId}</strong></span>

        <button
          onClick={() => handleDownloadStackExcel(result.stackId)}
          className="download-btn"
          style={{
            fontSize: "0.85rem",
            padding: "6px 12px",
            backgroundColor: "#217346", // Couleur verte Excel
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "5px"
          }}
          title="Télécharger l'Excel avec les images S3"
        >
          📊 {t("menu.exportExcel")}
        </button>
      </div>
      {/* --------------------------------------------------------- */}

      <div className="stack-timeline">
        {ordreAffiche.map((key) => {
          const info            = result.etapes?.[key];
          const done            = !!info;
          const cfg = ETAPE_CONFIG[key] || { label: key, icon: "•" };
          const label = t(`etapes.${key}`, cfg.label);
          const icon = cfg.icon;
          return (
            <div key={key} className={`timeline-step ${done ? "done" : "pending"}`}>
              <div className="timeline-dot">{done ? "✅" : "⬜"}</div>
              <div className="timeline-content">
                <span className="timeline-label">{icon} {label}</span>
                {done && (
                  <span className="timeline-meta">
                    {info.Operateur}{info.Date && ` · ${info.Date}`}
                  </span>
                )}

                {/* Empilement */}
                {done && key === "Empilement" && (
                  <div className="timeline-details">
                    {info.Strategie     && <span>{ui("Stratégie")} : {info.Strategie}</span>}
                    {info.TotalPlis > 0 && <span>{ui("Total plis")} : {info.TotalPlis}</span>}
                    {info.PN1           && <span>PN1 : {info.PN1}</span>}
                    {info.PN2           && <span>PN2 : {info.PN2}</span>}
                    {info.PN3           && <span>PN3 : {info.PN3}</span>}
                    {info.Rows?.length > 0 && (
                      <div className="plypn-section">
                        <button className="plypn-toggle" onClick={() => setExpandedRows((v) => !v)}>
                          {expandedRows
                            ? `▲ ${t("common.hidePlies")}`
                            : `▼ ${t("common.showPlies", { n: info.Rows.length })}`}
                        </button>
                        {expandedRows && (
                          <div className="plypn-list">
                            {info.Rows.map((row) => (
                              <div key={row.Position} className="plypn-row">
                                <span className="plypn-pos">#{row.Position}</span>
                                <span className="plypn-val">{row.PlyPN}</span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {/* Imprégnation */}
                {done && key === "Impregnation" && (
                  <div className="timeline-details">
                    {info.MelangePN        && <span>{ui("Mélange PN")} : {info.MelangePN}</span>}
                    {info.DureeTraitement   && <span>{ui("Durée")} : {info.DureeTraitement} min</span>}
                    {info.TotalPlis > 0     && <span>{ui("Total plis")} : {info.TotalPlis}</span>}
                    {Number(info.Temperature) > 0 && ( // ✅ FIX Bug 3
                      <span>{ui("Température")} : {info.Temperature}°C</span>
                    )}
                    {info.Rows?.length > 0 && (
                      <div className="plypn-section">
                        <button className="plypn-toggle" onClick={() => setExpandedRows((v) => !v)}>
                          {expandedRows
                            ? `▲ ${t("common.hidePlies")}`
                            : `▼ ${t("common.showPlies", { n: info.Rows.length })}`}
                        </button>
                        {expandedRows && (
                          <div className="plypn-list">
                            {info.Rows.map((row) => (
                              <div key={row.Position} className="plypn-row">
                                <span className="plypn-pos">#{row.Position}</span>
                                <span className="plypn-val">{row.PlyPN}</span>
                                {Number(row.MasseApresTraitement) > 0 && (
                                  <span className="plypn-meta">{row.MasseApresTraitement} g</span>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {/* Traitement thermique */}
                {done && key === "TraitementThermique" && (
                  <div className="timeline-details">
                    {info.EnceinteId               && <span>{ui("Enceinte")} : {info.EnceinteId}</span>}
                    {Number(info.Temperature) > 0  && ( // ✅ FIX Bug 3
                      <span>{ui("Température")} : {info.Temperature}°C</span>
                    )}
                  </div>
                )}

                {/* Fabrication */}
                {done && key === "Fabrication" && (
                  <div className="timeline-details">
                    {info.CyclePressageCuisson && <span>Cycle : {info.CyclePressageCuisson}</span>}
                    {info.ParcPresse1          && <span>Presse 1 : {info.ParcPresse1}</span>}
                    {info.ParcPresse2          && <span>Presse 2 : {info.ParcPresse2}</span>}
                  </div>
                )}

                {/* Aboutage */}
                {done && key === "Aboutage" && (
                  <div className="timeline-details">
                    {info.FinalStackId    && <span>Final Stack : {info.FinalStackId}</span>}
                    {info.TotalStacks > 0 && <span>Total stacks : {info.TotalStacks}</span>}
                  </div>
                )}

                {/* Qualité Stack */}
                {done && key === "QualiteStack" && (
                  <div className="timeline-details">
                    <span className={info.Conformite === "CONFORME" ? "conformite-ok" : "conformite-nok"}>
                      {info.Conformite === "CONFORME" ? "✓" : "✗"} {info.Conformite}
                    </span>
                    {info.Epaisseur_Moyenne && <span>Ép. moy. : {info.Epaisseur_Moyenne}</span>}
                    {info.Taux_Compression  && <span>Taux compr. : {Number(info.Taux_Compression).toFixed(2)} %</span>}
                    {info.Ecart_Max_Ep      && <span>Écart max : {Number(info.Ecart_Max_Ep).toFixed(2)} mm</span>}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

  // ── Render résultat PlyPN ────────────────────────────────
  // ✅ FIX Bug 3 : Number() sur la température
  function renderPlyPNResult(result) {
    const icon = ETAPE_CONFIG[result.etape]?.icon || "📍";
    const detailRows = [
      [ui("Stack ID"),    result.stackId],
      [ui("Position"),    result.position != null ? `${result.position} / ${result.totalPlis}` : null],
      [ui("Opérateur"),   result.operateur],
      [ui("Date"),        result.date],
      [ui("Commentaire"), result.commentaire],
      [ui("Mélange PN"),  result.details?.melangePN],
      [ui("Enceinte"),    result.details?.enceinte],
      [ui("Stratégie"),   result.details?.strategie],
      ["Presse 1",    result.details?.parcPresse1],
      ["Presse 2",    result.details?.parcPresse2],
    ];
    return (
      <>
        <div className="result-header">✅ <strong>{result.plypn}</strong></div>
        <div className="result-info">
          <span className={`etape-badge etape-${result.etape?.toLowerCase().replace(/\s+/g, "-")}`}>
            {icon} {result.etape}
          </span>
        </div>
        <div className="plypn-details">
          {detailRows.map(([label, value]) =>
            value && value !== "N/A" ? (
              <div key={label} className="detail-row">
                <span className="label">{label} :</span>
                <span className="value">{value}</span>
              </div>
            ) : null
          )}
          {/* ✅ FIX Bug 3 : Number() pour la comparaison */}
          {Number(result.details?.temperature) > 0 && (
            <div className="detail-row">
              <span className="label">{ui("Température")} :</span>
              <span className="value">{result.details.temperature}°C</span>
            </div>
          )}
          {result.imageUrl && (
            <div className="detail-row image-row">
              <span className="label">{ui("Image S3")} :</span>
              <div className="value">
                {result.imageCorrected && (
                  <span className="etat-badge" style={{ marginBottom: 8, display: "inline-block" }}>
                    Couleur corrigée
                  </span>
                )}
                <img src={result.imageUrl} alt={`Image ${result.plypn}`} className="plypn-image" />
                <a href={result.imageUrl} download={`${result.plypn}.png`} className="download-btn" target="_blank" rel="noreferrer">
                  ⬇️ {t("common.download")}
                </a>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }

  // ── Render résultat PN ───────────────────────────────────
  function renderPNResult(result) {
    return (
      <>
        <div className="result-header">✅ <strong>{result.pn}</strong></div>
        <div className="result-info">
          <span className={`etat-badge etat-${result.etat?.toLowerCase().replace(/\s+/g, "-")}`}>
            {result.etat}
          </span>
          <span className="result-details">
            {result.fournisseur && `• ${result.fournisseur}`}
            {result.date        && ` • ${result.date}`}
          </span>
        </div>
        <button className="view-details-btn" onClick={() => navigate(`/logistique/stock/bois?pn=${encodeURIComponent(result.pn)}`)}>
          {t("menu.seeDetails")} →
        </button>
      </>
    );
  }

  // ── Render principal ─────────────────────────────────────
  return (
    <div className="menu-root">
      <div className="menu-wrap">

        {/* ══ HEADER ══ */}
        <div className="menu-header">
          <button className="config-btn" onClick={() => navigate("/admin/users")} title={t("common.config")}>
            <img src={configIcon} alt={t("common.config")} className="header-icon" />
          </button>
          <div className="logo">
            <div className="logo-title">WOODOO</div>
            <div className="logo-sub">AUGMENTED WOOD</div>
          </div>
          <div className="header-actions" style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <button className="logout-btn" onClick={handleLogout} title={t("common.logout")}>
              <img src={logoutIcon} alt={t("common.logout")} className="header-icon" />
            </button>
          </div>
        </div>

        {/* ══ BARRE DE RECHERCHE ══ */}
        <div className="search-pn-container" ref={searchAreaRef}>
          <form onSubmit={handleSearchPN} className="search-pn-form">
            <div className="autocomplete-wrapper">
              <input
                type="text"
                value={searchPN}
                onChange={handleInputChange}
                onBlur={() => setTimeout(() => setShowSuggestions(false), 150)}
                onFocus={() => suggestions.length > 0 && setShowSuggestions(true)}
                placeholder={t("menu.searchPlaceholder")}
                className="search-pn-input"
                disabled={searchLoading}
                autoComplete="off"
              />
              {showSuggestions && suggestions.length > 0 && (
                <ul className="autocomplete-list">
                  {suggestions.map((s, i) => (
                    <li key={i} className="autocomplete-item" onMouseDown={() => handleSelectSuggestion(s)}>
                      <span className="autocomplete-value">{s.value}</span>
                      <span className={`autocomplete-badge ${s.type === "PlyPN" ? "badge-plypn" : "badge-pn"}`}>
                        {s.type}
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <button type="submit" className="search-pn-btn" disabled={searchLoading}>
              {searchLoading ? "..." : t("common.search")}
            </button>
          </form>

          {searchResult && (
            <div ref={resultRef} className={`search-result ${searchResult.found ? "success" : "error"}`}>
              <button type="button" className="search-result-close" onClick={handleCloseSearchResult} aria-label={t("common.close")}>✕</button>
              {searchResult.found ? (
                <>
                  {searchResult.type === "pn"    && renderPNResult(searchResult)}
                  {searchResult.type === "plypn" && renderPlyPNResult(searchResult)}
                  {searchResult.type === "stack" && renderStackResult(searchResult)}
                </>
              ) : (
                <div>{searchResult.message}</div>
              )}
            </div>
          )}
        </div>

        {/* ══ ONGLETS ══ */}
        <div className="tabs-container">
          <button
            className="hamburger-btn"
            onClick={() => setMobileMenuOpen((v) => !v)}
            aria-label={t("common.menu")}
          >
            <span className="hamburger-label">{active ? t(`nav.${active}`) : t("common.menu")}</span>
            <span className="hamburger-icon">{mobileMenuOpen ? "✕" : "☰"}</span>
          </button>
          <div className={`tabs ${mobileMenuOpen ? "tabs-open" : ""}`}>
            {SECTIONS.map((sec) => (
              <button
                key={sec}
                className={`tab ${active === sec ? "tab-active" : ""}`}
                onClick={() => onTab(sec)}
              >
                {t(`nav.${sec}`)}
              </button>
            ))}
          </div>
        </div>

        <hr className="divider" />

        {/* ══ LISTE MENU ══ */}
        <div className="list">
          {loading && <div className="loading">{t("common.loading")}</div>}
          {err     && <div className="hint">{err}</div>}
          {!loading && !err && items.length === 0 && active && (
            <div className="hint">{t("common.selectMenuItem")}</div>
          )}
          {items.map(renderItem)}
        </div>

      </div>
    </div>
  );
}